<script>

export default {
    name: "Error500",
}
</script>

<template>
    <div class="row mt-5">
        <div class="offset-md-3 col-md-6">
            <div class="bg-white p-4 shadow-sm rounded-lg">
                <h4 class="font-weight-bold mb-3">Error 500</h4>
                <p>Internal server error</p>

                <button class="btn btn-outline-secondary" @click="$router.go(-1)">Go Back</button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>